<template>
  <div v-loading="loading">
    <back />
    <div class="det">
      <div class="top">
        <div class="title">游学信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row type="flex" justify="space-between">
            <el-col>
              <el-form-item label="封面图片:">
                <el-image style="width: 80px;height: 80px; " :src="url" :preview-src-list="[url]" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline" style="font-size: 80px;color: #2a2a2a;"></i>
                  </div>
                </el-image>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="游学名称:">
                <div>{{ ruleForm.name }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="人  数:">
                <div>{{ ruleForm.peopleCount }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="销售价:">
                <div>{{ ruleForm.price }} 元</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="类目:">
                <div>{{ ruleForm.categoryName }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="带队老师:">
                <div>{{ ruleForm.teacherName }}</div>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="5">
              <el-form-item label="购买人数:">
                <div>{{ ruleForm.signUpCount || '--' }}</div>
              </el-form-item>
            </el-col> -->
            <el-col :span="11">
              <el-form-item label="游学时间:">
                <div>{{ `${ruleForm.startTime} ~ ${ruleForm.endTime}` }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5"></el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 售后信息 -->
      <div class="top">
        <div class="title">售后信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="售后单号：">
                <div>{{ ruleForm.refundCode }}</div>
              </el-form-item>
              <el-form-item label="下单时间：">
                <div>{{ ruleForm.orderTime }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单编号：">
                <div>{{ ruleForm.orderNum }}</div>
              </el-form-item>
              <el-form-item label="申请时间：">
                <div>{{ ruleForm.createdTime }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="售后状态：">
                <!-- <div v-if="ruleForm.status == -1">已撤销</div> -->
                <div v-if="ruleForm.status == 0">处理中</div>
                <div v-if="ruleForm.status == 1">已退款</div>
                <div v-if="ruleForm.status == 2">拒绝退款</div>
              </el-form-item>
              <el-form-item label="处理时间：" v-if="ruleForm.status !== 0">
                <div>{{ ruleForm.auditTime }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="退款金额:">
                <div>{{ ruleForm.refundAmount }} 元</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col>
              <el-form-item label="售后原因:" label-width="90px">
                <div>{{ ruleForm.refundMsg || '--' }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row type="flex" justify="space-between">
            <el-col>
              <el-form-item label="售后凭证:" label-width="90px">
                <el-image v-for="item, index in srcList" :key="index"
                  style="width: 80px; height: 80px; margin-right: 10px;" :src="item" :preview-src-list="[item]"
                  fit="contain">
                </el-image>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row type="flex" justify="space-between" v-if="ruleForm.status == 2">
            <el-col>
              <el-form-item label="拒绝理由:" label-width="90px">
                <div>{{ ruleForm.refuseMsg }}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 用户信息 -->
      <div class="top">
        <div class="title">用户信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="用户编号：">
                <div>{{ ruleForm.userCode }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="用户昵称：">
                <div>{{ ruleForm.userName }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5"></el-col>
            <el-col :span="5"></el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 退款信息 -->
      <div class="top">
        <div class="title">退款学员信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="姓名：">
                <div>{{ ruleForm.studyTourUserName || '--' }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="电话号码：">
                <div>{{ ruleForm.studyTourUserPhone || '--' }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="身份证号码：">
                <div>{{ ruleForm.studyTourUserIdCard || '--' }}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      ruleForm: {},//订单信息
      url: '',//封面图
      // srcList: [
      //   'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
      //   'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      // ]
    };
  },
  created() {
    this.getRequest()
  },
  methods: {
    getRequest() {
      this.loading = true;
      this.$axios.get(this.$api.studyTourOrderRefundListDet, {
        params: {
          id: this.$route.query.id,
        },
      }).then((res) => {
        const { code, result } = res
        this.loading = false;
        if (code == 100) {
          this.ruleForm = result//订单信息
          this.url = result.pictureList[0]
        }
      }).catch((err) => {
        this.$message.error(err.desc)
        this.loading = false;
      })
    },
  }
}
</script>

<style scoped lang='scss'>
.det {
  padding: 10px 0 0 10px;

  .title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #1A1A1A;
    text-align: left;
    margin-bottom: 20px;
  }

  .top {
    border-bottom: 1px solid #E2E2E2;
    margin-bottom: 30px;
    padding-bottom: 20px;

    .el-form-item {
      margin-bottom: 0px;
    }
  }

  .bottom {
    display: flex;
    align-items: flex-end;
    color: #505554;
    font-weight: bold;
    justify-content: flex-end;
    padding: 10px 0;

    div {
      margin-right: 20px;
    }
  }

}
</style>